<div class="identidade">
  <header class="id-cabecalho">
    <div>
      <h3 class="id-titulo">Identidade visual</h3>
      <p class="id-subtitulo">Capa, logo e ícone que o cliente vê assim que abre a sua loja.</p>
    </div>
    <a class="id-botao-secundario" *ngIf="empresa?.linkLoja" [href]="empresa.linkLoja" target="_blank" rel="noopener">
      <i class="fe-external-link"></i> Ver minha loja
    </a>
  </header>

  <div class="id-grade">
    <div class="id-coluna">
      <section class="id-card">
        <!-- Capa -->
        <div class="id-item" (mouseenter)="capaUpload.marqueComoAtiva()">
          <div class="id-item-linha">
            <div class="id-miniatura id-miniatura--capa" [class.is-vazia]="!temImagem('capa')">
              <img *ngIf="temImagem('capa')" [src]="urlImagem('capa')" alt="Capa atual" (error)="marqueQuebrada('capa')">
              <i *ngIf="!temImagem('capa')" class="fe-image"></i>
            </div>

            <div class="id-item-texto">
              <div class="id-item-titulo">
                Capa
                <span class="id-selo" [class.is-ok]="temImagem('capa')">{{ temImagem('capa') ? 'Configurada' : 'Pendente' }}</span>
              </div>
              <p class="id-item-descricao">Imagem larga no topo da loja. É a primeira coisa que o cliente vê.</p>
              <div class="id-specs">
                <span>Proporção 4:1</span>
                <span>Mínimo 992 × 240 px</span>
              </div>
            </div>

            <div class="id-item-acoes" *ngIf="!editorAberto(capaUpload)">
              <button type="button" class="id-botao" (click)="abraEditor(capaUpload)">
                <i class="fe-upload"></i> Trocar capa
              </button>
              <small class="id-dica-colar">ou passe o mouse aqui e cole com <kbd>{{ teclaColar }}</kbd><kbd>V</kbd></small>
            </div>
          </div>

          <div class="id-editor" [hidden]="!editorAberto(capaUpload)">
            <div class="id-editor-topo">
              <span>{{ temImagem('capa') ? 'Nova capa' : 'Envie a capa da loja' }}</span>
              <button type="button" class="id-link" *ngIf="empresa?.capa && !capaUpload.salvar" (click)="fecheEditor(capaUpload)">Cancelar</button>
            </div>
            <app-upload-crop-imagem #capaUpload ratio="4" [resizeWidth]="1240" [minWidth]="992" [minHeight]="240"
                                    [semCabecalho]="true" [colarParaTrocar]="true"
                                    [objeto]="empresa" [prop]="'capa'" [label]="'Capa'" (onEnviou)="salveCapaEmpresa($event)"></app-upload-crop-imagem>
          </div>
        </div>

        <!-- Logo -->
        <div class="id-item" (mouseenter)="logoUpload.marqueComoAtiva()">
          <div class="id-item-linha">
            <div class="id-miniatura id-miniatura--logo" [class.is-vazia]="!temImagem('logo')">
              <img *ngIf="temImagem('logo')" [src]="urlImagem('logo')" alt="Logo atual" (error)="marqueQuebrada('logo')">
              <span *ngIf="!temImagem('logo')">{{ inicial() }}</span>
            </div>

            <div class="id-item-texto">
              <div class="id-item-titulo">
                Logo
                <span class="id-selo" [class.is-ok]="temImagem('logo')">{{ temImagem('logo') ? 'Configurada' : 'Pendente' }}</span>
              </div>
              <p class="id-item-descricao">Aparece sobre a capa, nos pedidos e quando o link da loja é compartilhado.</p>
              <div class="id-specs">
                <span>Quadrada</span>
                <span>Mínimo 300 × 300 px</span>
              </div>
            </div>

            <div class="id-item-acoes" *ngIf="!editorAberto(logoUpload)">
              <button type="button" class="id-botao" (click)="abraEditor(logoUpload)">
                <i class="fe-upload"></i> Trocar logo
              </button>
              <small class="id-dica-colar">ou passe o mouse aqui e cole com <kbd>{{ teclaColar }}</kbd><kbd>V</kbd></small>
            </div>
          </div>

          <div class="id-editor id-editor--logo" [hidden]="!editorAberto(logoUpload)">
            <div class="id-editor-topo">
              <span>{{ temImagem('logo') ? 'Nova logo' : 'Envie a logo da loja' }}</span>
              <button type="button" class="id-link" *ngIf="empresa?.logo && !logoUpload.salvar" (click)="fecheEditor(logoUpload)">Cancelar</button>
            </div>
            <app-upload-crop-imagem #logoUpload [objeto]="empresa" ratio="1" [minHeight]="300" [minWidth]="300" [widthExibir]="200"
                                    [semCabecalho]="true" [colarParaTrocar]="true"
                                    [uploadUrl]="'/upload/imagem/logoempresa'" [prop]="'logo'" [label]="'Logo'" [maiorPossivel]="true"
                                    (onEnviou)="salveLogoEmpresa($event)"></app-upload-crop-imagem>
          </div>
        </div>

        <!-- Favicon -->
        <div class="id-item">
          <div class="id-item-linha">
            <div class="id-aba-navegador">
              <span class="id-aba-bolinhas"><i></i><i></i><i></i></span>
              <span class="id-aba">
                <img *ngIf="temImagem('favicon')" [src]="urlImagem('favicon')" alt="" (error)="marqueQuebrada('favicon')">
                <i *ngIf="!temImagem('favicon')" class="fe-globe"></i>
                <span>{{ empresa?.nome || 'Minha loja' }}</span>
              </span>
            </div>

            <div class="id-item-texto">
              <div class="id-item-titulo">
                Ícone da aba
                <span class="id-selo" [class.is-ok]="temImagem('favicon')">{{ temImagem('favicon') ? 'Configurado' : 'Opcional' }}</span>
              </div>
              <p class="id-item-descricao">O ícone pequeno na aba do navegador. Disponível para lojas com domínio próprio.</p>
              <div class="id-specs">
                <span>Arquivo .ico</span>
              </div>
            </div>

            <div class="id-item-acoes" *ngIf="!editandoFavicon">
              <button type="button" class="id-botao" (click)="editandoFavicon = true">
                <i class="fe-upload"></i> {{ temImagem('favicon') ? 'Trocar ícone' : 'Enviar ícone' }}
              </button>
            </div>
          </div>

          <div class="id-editor" *ngIf="editandoFavicon">
            <div class="id-editor-topo">
              <span>Novo ícone da aba</span>
              <button type="button" class="id-link" (click)="editandoFavicon = false">Fechar</button>
            </div>
            <app-tela-upload-favicon [empresa]="empresa"></app-tela-upload-favicon>
          </div>
        </div>
      </section>
    </div>

    <!-- Prévia -->
    <aside class="id-previa" aria-label="Prévia do topo da loja">
      <span class="id-previa-rotulo">Prévia no celular</span>
      <div class="id-celular">
        <div class="id-celular-tela">
          <div class="id-celular-capa">
            <img *ngIf="temImagem('capa')" [src]="urlImagem('capa')" alt="">
          </div>
          <div class="id-celular-cabecalho">
            <div class="id-celular-logo">
              <img *ngIf="temImagem('logo')" [src]="urlImagem('logo')" alt="">
              <span *ngIf="!temImagem('logo')">{{ inicial() }}</span>
            </div>
            <strong class="id-celular-nome">{{ empresa?.nome || 'Minha loja' }}</strong>
            <span class="id-celular-status"><i></i> Aberto agora</span>
          </div>
          <div class="id-celular-esqueleto">
            <div class="id-esq-chips"><i></i><i></i><i></i></div>
            <div class="id-esq-banner"></div>
            <div class="id-esq-produto" *ngFor="let p of [1, 2, 3]">
              <div><i class="id-esq-linha"></i><i class="id-esq-linha curta"></i></div>
              <span class="id-esq-foto"></span>
            </div>
          </div>
        </div>
      </div>
    </aside>
  </div>
</div>

<section class="id-card id-ambiente" *ngIf="fotosDoAmbiente">
  <div class="id-editor-topo">
    <span>Imagens do ambiente da empresa</span>
  </div>
  <kendo-grid [pageSize]="paginacao.size"
              [skip]="paginacao.skip"
              [style]=""
              [kendoGridBinding]="fotos"
              [loading]="loading" style="min-height: 300px;"
              [scrollable]="'none'"
              footerStyle="font-size: 11px;"
              [pageable]="{
                buttonCount: paginacao.buttonCount,
                info: paginacao.info,
                type: 'numeric',
                pageSizes: paginacao.pageSizes,
                previousNext: paginacao.previousNext
              }"
              (edit)="editarFoto($event)"
              (remove)="abraDialogRemoverfoto($event)"
              (pageChange)="mudouPaginacao({$event : $event})">
    <ng-template kendoGridToolbarTemplate [position]="'top'">
      <button class="k-button btn-primary" (click)="novaFoto()">
        Novo
      </button>
    </ng-template>
    <kendo-grid-messages
      pagerPage="Página"
      pagerOf="de"
      pagerItems="itens"
      noRecords="Sem fotos"
      loading="Carregando"
      pagerItemsPerPage="ítems por página"
    >
    </kendo-grid-messages>
    <kendo-grid-column title="ID" class="coluna_menor"   [width]="70">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span>{{dataItem.id}}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Imagem" class="coluna_menor" [width]="120">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <img [src]="'/images/empresa/'+dataItem.link" style="width: 80px;">
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Descricao" class="coluna_menor">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span><b>{{dataItem.titulo}}</b></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Nome" class="coluna_menor">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span>{{dataItem.descricao}}</span>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column title="Foto" class="coluna_menor">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span>{{dataItem.link}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column title="" [width]="150">
      <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
        <button kendoGridEditCommand [primary]="true" (selectedChange)="editarFoto(dataItem)">Editar</button>
        <button kendoGridRemoveCommand><i class="fa fa-trash"></i></button>
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
  <kendo-dialog title="Atenção!" *ngIf="abraDialogo" (close)="fechar()" [minWidth]="250" [width]="450">
    <div *ngIf="fotoSelecionada && !excluindoFoto">
      <p style="margin: 30px; text-align: center;">Esta operação é irreversível. Tem certeza que deseja excluir a foto "<strong>{{fotoSelecionada.titulo}}?</strong>"</p>
    </div>
    <div *ngIf="excluindoFoto">
      <p style="margin: 30px; text-align: center;">Excluindo a foto "<strong>{{fotoSelecionada.titulo}}"...</strong></p>
      <div class="k-i-loading ml-1 mr-1" style="font-size: 20px; padding-bottom: 20px  " ></div>
    </div>
    <div *ngIf="mensagemRemocao">
      <p style="margin: 30px; text-align: center;">{{mensagemRemocao}}</p>
    </div>

    <div class="modal-footer" *ngIf="!excluindoFoto">
      <button type="button" *ngIf="fotoSelecionada" (click)="removaFoto()" class="btn btn-primary waves-effect waves-light" >Remover</button>
      <button type="button" *ngIf="fotoSelecionada" (click)="fechar()" kendoButton [primary]="true" class="btn btn-light waves-effect">Cancelar</button>
      <button type="button" *ngIf="!fotoSelecionada" (click)="fechar()" class="btn btn-primary waves-effect waves-light" >Fechar</button>
    </div>
  </kendo-dialog>
</section>
